import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import i18n from "i18next";

import { Export } from "../../Common/Export/Export";
import { FormDropDown } from "../../Common";
import { exportRolls } from "../../../helpers/xlsxHelpers";
import { getCustomerPOs, getDimensions, getProductNames } from "./FilterHelpers";

class Filters extends PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    billOfLading: PropTypes.object,
    rolls: PropTypes.array,
    selectedCustomerPO: PropTypes.string,
    selectedDimension: PropTypes.string,
    selectedProductName: PropTypes.string,
    selectedRollKeyBy: PropTypes.string,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    billOfLading: {},
    rolls: [],
    selectedCustomerPO: null,
    selectedDimension: null,
    selectedProductName: null,
    selectedRollKeyBy: "tappiId",
    userMetadata: {}
  };

  state = {
    isDropdownOpen: false
  };

  componentDidMount() {
    document.body.addEventListener("click", this.handleCloseDropdown);
  }

  componentWillUnmount() {
    document.body.removeEventListener("click", this.handleCloseDropdown);
  }

  get products() {
    return this.props.billOfLading.products || [];
  }

  handleExportRolls = isXLSX => {
    const { billOfLading, rolls, selectedRollKeyBy, userMetadata } = this.props;
    exportRolls(rolls, billOfLading, selectedRollKeyBy, userMetadata.dateDisplayFormat, isXLSX);
  };

  handleCloseDropdown = () => this.setState({ isDropdownOpen: false });

  handleExportCSVClick = () => this.handleExportRolls(false);

  handleExportExcelClick = () => this.handleExportRolls(true);

  handleToggleDropdown = () => this.setState({ isDropdownOpen: !this.state.isDropdownOpen });

  handleFieldChange = (_field, value, _oldValue, fieldName) => this.props.onSubmit(fieldName, value);

  actions = [
    {
      label: i18n.t("export.csvFile"),
      key: "csv",
      onClick: this.handleExportCSVClick
    },
    {
      label: i18n.t("export.excelFile"),
      key: "xlsx",
      onClick: this.handleExportExcelClick
    }
  ];

  render() {
    const { selectedCustomerPO, selectedDimension, selectedProductName } = this.props;

    const customerPOs = getCustomerPOs(this.products, selectedProductName, selectedDimension);
    const productNames = getProductNames(this.products, selectedCustomerPO, selectedDimension);
    const dimensions = getDimensions(this.products, selectedCustomerPO, selectedProductName);

    return (
      <div className="filters">
        <div className="filters__filter --label">
          <span>{i18n.t("billsOfLading.showingRollsFor")}</span>
        </div>
        <div className="filters__filter">
          <Field
            component={FormDropDown}
            data={customerPOs}
            name="selectedCustomerPO"
            noLabel
            onChange={this.handleFieldChange}
            placeholder={i18n.t("billsOfLading.all")}
            selectedValue={this.props.selectedCustomerPO}
            valueContainerLabel={i18n.t("billsOfLading.PO")}
            selectClassName="--small"
            wrapperClassName="--no-margin"
          />
        </div>
        <div className="filters__filter">
          <Field
            component={FormDropDown}
            data={productNames}
            name="selectedProductName"
            onChange={this.handleFieldChange}
            noLabel
            placeholder={i18n.t("billsOfLading.all")}
            selectedValue={this.props.selectedProductName}
            valueContainerLabel={i18n.t("billsOfLading.products")}
            selectClassName="--small"
            wrapperClassName="--no-margin"
          />
        </div>
        <div className="filters__filter">
          <Field
            component={FormDropDown}
            data={dimensions}
            name="selectedDimension"
            onChange={this.handleFieldChange}
            noLabel
            placeholder={i18n.t("billsOfLading.all")}
            selectedValue={this.props.selectedDimension}
            valueContainerLabel={i18n.t("billsOfLading.dimensions")}
            selectClassName="--small"
            wrapperClassName="--no-margin"
          />
        </div>
        <div className="filters__filter --last">
          <Export actions={this.actions} filter />
        </div>
      </div>
    );
  }
}

export default reduxForm({ form: "filters", enableReinitialize: true })(Filters);



// WEBPACK FOOTER //
// ./src/components/BillOfLading/Filters/Filters.js